<template>
    <component :is="drawer?'Drawer':'Modal'"
      :value="value"
      footer-hide
      icon="md-document"
      :title="(data.id?'编辑':'新建') +' - ' + this.formDef.name"
      @input="$emit('input',$event)"
      :width="width"
      >
      <BaseLoading v-if="loading_model">加载中</BaseLoading>
      <template v-else>
        <Button type="primary" @click="openAiDialog" style="margin-bottom:10px;">
          <Icon type="md-bulb" /> AI填表
        </Button>
      <UgoForm
        ref="form"
        :key="formRenderKey"
        :form="formDef"
        v-model="formData"
        :old="data"
        @on-submit="handleSubmit"
        />
      </template>
      <div class="flex-wrap flex-right">
        <Button type="primary" @click="submit">提交</Button>
        <Button @click="$emit('input',false)" style="margin-left:10px">取消</Button>
      </div>

      <Modal
        :value="showAIEditor"
        title=""
        footer-hide
        :width="760"
        transfer
        :mask-closable="!aiLoading && !aiFileParsing"
        :closable="!aiLoading && !aiFileParsing"
        class-name="ugo-ai-fill-modal"
        @on-visible-change="onAiModalVisible"
      >
        <div slot="header" class="ugo-ai-fill-modal__header">
          <div class="ugo-ai-fill-modal__header-icon">
            <Icon type="md-bulb" size="22" />
          </div>
          <div>
            <div class="ugo-ai-fill-modal__title">AI 智能填表</div>
            <div class="ugo-ai-fill-modal__subtitle">描述需求或上传附件，生成后确认再写入表单</div>
          </div>
        </div>

        <div class="ugo-ai-fill-modal__body">
          <div class="ugo-ai-fill-modal__steps">
            <span :class="{ active: aiPhase === 'input' }">1. 输入</span>
            <span :class="{ active: aiPhase === 'parsing' }">2. 解析附件</span>
            <span :class="{ active: aiPhase === 'streaming' }">3. 生成</span>
            <span :class="{ active: aiPhase === 'preview' }">4. 确认</span>
          </div>

          <div v-show="aiPhase === 'parsing'" class="ugo-ai-fill-modal__section ugo-ai-fill-modal__parsing">
            <div class="ugo-ai-fill-modal__section-title">
              <Icon type="ios-loading" class="ugo-ai-parse-spin" />
              正在解析附件
            </div>
            <div class="ugo-ai-fill-modal__parsing-bar">
              <div
                class="ugo-ai-fill-modal__parsing-bar-inner"
                :style="{ width: aiFileParsePercent + '%' }"
              />
            </div>
            <ul class="ugo-ai-fill-modal__parsing-list">
              <li
                v-for="(f, i) in aiParsingFileList"
                :key="f.name + '-' + i"
                :class="{
                  done: i < aiFileParseDone,
                  active: i === aiFileParseDone && aiFileParsing,
                }"
              >
                <Icon
                  :type="i < aiFileParseDone ? 'md-checkmark-circle' : (i === aiFileParseDone && aiFileParsing ? 'ios-loading' : 'ios-document-outline')"
                  :class="{ 'ugo-ai-parse-spin': i === aiFileParseDone && aiFileParsing }"
                />
                <span class="ugo-ai-fill-modal__parsing-name">{{ f.name }}</span>
              </li>
            </ul>
          </div>

          <div v-show="aiPhase === 'input'" class="ugo-ai-fill-modal__section">
            <BaseMultiInput
              v-model="aiInput"
              :disabled="aiLoading || aiFileParsing"
              placeholder="请描述填表需求，例如：根据招标文件摘要填写项目信息与投标报价…"
            />
          </div>

          <div v-show="aiPhase === 'streaming'" class="ugo-ai-fill-modal__status">
            <div class="ugo-ai-fill-modal__status-card is-streaming">
              <div class="ugo-ai-fill-modal__pulse-wrap">
                <span class="ugo-ai-fill-modal__pulse-ring ugo-ai-fill-modal__pulse-ring--2" />
                <span class="ugo-ai-fill-modal__pulse-ring" />
                <span class="ugo-ai-fill-modal__pulse-core">
                  <Icon type="md-bulb" size="26" />
                </span>
              </div>
              <p class="ugo-ai-fill-modal__status-title">AI 正在生成填表数据</p>
              <p class="ugo-ai-fill-modal__status-hint">请稍候，完成后可确认填入表单</p>
              <div class="ugo-ai-fill-modal__status-dots">
                <span /><span /><span />
              </div>
            </div>
          </div>

          <div v-show="aiPhase === 'preview'" class="ugo-ai-fill-modal__status">
            <div class="ugo-ai-fill-modal__status-card is-success">
              <div class="ugo-ai-fill-modal__success-icon">
                <Icon type="md-checkmark-circle" size="52" />
              </div>
              <p class="ugo-ai-fill-modal__status-title">生成完成</p>
              <p class="ugo-ai-fill-modal__status-hint">
                已识别 {{ aiPreviewFieldCount }} 个字段，点击下方确认写入表单
              </p>
            </div>
          </div>

          <Alert
            v-if="aiParseFailed && aiParseError"
            type="error"
            show-icon
            style="margin-bottom:10px;"
          >
            {{ aiParseError }}。请调整后点击「重新生成」。
          </Alert>

          <div v-if="aiMessage" class="ugo-ai-fill-modal__message" :class="aiMessageType">
            {{ aiMessage }}
          </div>
        </div>

        <div class="ugo-ai-fill-modal__footer flex-wrap flex-right">
          <template v-if="aiPhase === 'preview'">
            <Button @click="resetAiPreview" :disabled="aiLoading">返回修改</Button>
            <Button
              type="primary"
              :disabled="!aiParsedPayload || !Object.keys(aiParsedPayload).length"
              @click="confirmApplyAi"
            >
              确认填入表单
            </Button>
          </template>
          <template v-else>
            <Button @click="closeAiDialog" :disabled="aiLoading || aiFileParsing">取消</Button>
            <Button
              type="primary"
              :loading="aiLoading || aiFileParsing"
              :disabled="aiLoading || aiFileParsing"
              @click="aiParseFailed ? retryAiGenerate() : submitAI()"
            >
              <Icon :type="aiParseFailed ? 'md-refresh' : 'md-send'" />
              {{ aiParseFailed ? '重新生成' : '开始生成' }}
            </Button>
          </template>
        </div>
      </Modal>
    </component>
  </template>

<script>
import {cloneDeep, debounce} from 'lodash';
import UgoForm from '@/components/form';

export default {
  components: {
    UgoForm,
  },
  created() {
    this.ensureAiReactiveState();
    this._submitAIDebounced = debounce(() => {
      this._submitAI();
    }, 600, {leading: true, trailing: false});
  },
  beforeDestroy() {
    if (this._submitAIDebounced && this._submitAIDebounced.cancel) {
      this._submitAIDebounced.cancel();
    }
    this._stopAiFileParseProgress();
  },
  computed: {
    aiPreviewFieldCount() {
      const p = this.aiParsedPayload;
      if (!p || typeof p !== 'object') {
        return 0;
      }
      return Object.keys(p).length;
    },
    aiFileParsePercent() {
      const total = this.aiParsingFileList.length;
      if (!total) {
        return 0;
      }
      if (!this.aiFileParsing && this.aiFileParseDone >= total) {
        return 100;
      }
      const done = Math.min(this.aiFileParseDone, total);
      return Math.round((done / total) * 100);
    },
  },
  props: {
    value: {
      type: Boolean,
    },
    drawer: {
      type: Boolean,
    },
    data: {
      type: Object,
      default: ()=>({}),
    },
    model: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 600,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.getData();
        }
      },
      deep: true,
      immediate: true,
    },
    data: {
      handler(v) {
        if (this.data && this.data.id) {
          this.formData = cloneDeep(this.data);
        } else {
          this.formData = this.initFormData();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      flow: {},
      formData: {},
      deps: [],
      submitting: false,
      loading_model: false,
      showAIEditor: false,
      aiModalKey: 0,
      aiLoading: false,
      aiMessage: '',
      aiMessageType: 'info',
      aiPhase: 'input',
      aiInput: {text: '', files: []},
      aiStreamRaw: '',
      aiPreviewJson: '',
      aiParsedPayload: null,
      aiParseError: '',
      aiParseFailed: false,
      aiFileParsing: false,
      aiParsingFileList: [],
      aiFileParseDone: 0,
      aiValueDefCache: null,
      formDef: {
        name: '',
        fields: [],
        config: {},
      },
      formRenderKey: 0,
    };
  },
  methods: {
    ensureAiReactiveState() {
      const defaults = {
        showAIEditor: false,
        aiModalKey: 0,
        aiLoading: false,
        aiMessage: '',
        aiMessageType: 'info',
        aiPhase: 'input',
        aiInput: {text: '', files: []},
        aiStreamRaw: '',
        aiPreviewJson: '',
        aiParsedPayload: null,
        aiParseError: '',
        aiParseFailed: false,
        aiFileParsing: false,
        aiParsingFileList: [],
        aiFileParseDone: 0,
        aiValueDefCache: null,
        formRenderKey: 0,
      };
      Object.keys(defaults).forEach((key) => {
        if (!(key in this.$data)) {
          this.$set(this, key, defaults[key]);
        }
      });
    },
    openAiDialog() {
      this.ensureAiReactiveState();
      this.aiLoading = false;
      this.showAIEditor = true;
    },
    closeAiDialog() {
      if (this.aiLoading) {
        return;
      }
      this.showAIEditor = false;
    },
    onAiModalVisible(visible) {
      this.showAIEditor = !!visible;
      if (!visible) {
        this.aiLoading = false;
      }
    },
    resetAiPreview() {
      this.clearAiGenerationState();
    },
    _aiIsStreamJsonValue(value) {
      if (value == null || typeof value !== 'object') {
        return false;
      }
      if (value instanceof Uint8Array || (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView && ArrayBuffer.isView(value))) {
        return false;
      }
      return true;
    },
    cleanAiJsonOutput(raw) {
      if (raw == null) {
        return '';
      }
      let s = String(raw).trim();
      s = s.replace(/^\uFEFF/, '');
      s = s.replace(/^```(?:json)?\s*/i, '').replace(/\s*```$/i, '').trim();
      s = s.replace(/\r\n/g, '\n');
      const lead = s.match(/[`"'{\[]/);
      if (lead && lead.index > 0) {
        s = s.slice(lead.index);
      }
      const firstBrace = s.indexOf('{');
      const firstBracket = s.indexOf('[');
      let start = -1;
      if (firstBrace !== -1 && firstBracket !== -1) {
        start = Math.min(firstBrace, firstBracket);
      } else {
        start = firstBrace !== -1 ? firstBrace : firstBracket;
      }
      if (start > 0) {
        s = s.slice(start);
      }
      const lastBrace = s.lastIndexOf('}');
      const lastBracket = s.lastIndexOf(']');
      const end = Math.max(lastBrace, lastBracket);
      if (end >= 0 && end < s.length - 1) {
        s = s.slice(0, end + 1);
      }
      return s.trim();
    },
    async waitInnerFormsReady(form, timeout = 5000) {
      const start = Date.now();
      while (Date.now() - start < timeout) {
        const pending = [];
        form.traversalFeilds(form.fields, (f) => {
          if (f.control !== 'UgoInnerForm' && f.control !== 'UgoMultiForm') {
            return;
          }
          let ref = form.$refs[f.key];
          if (Array.isArray(ref)) {
            ref = ref[0];
          }
          if (!ref || ref.loading) {
            pending.push(f.key);
            return;
          }
          if (f.control === 'UgoInnerForm' &&
            !(ref.formDef && Array.isArray(ref.formDef.fields) && ref.formDef.fields.length)) {
            pending.push(f.key);
          }
          if (f.control === 'UgoMultiForm' &&
            !(ref.formDef && Array.isArray(ref.formDef.fields) && ref.formDef.fields.length)) {
            pending.push(f.key);
          }
        });
        if (!pending.length) {
          return;
        }
        await new Promise((r) => setTimeout(r, 120));
        await this.$nextTick();
      }
    },
    async getFormValueDef() {
      await this.$nextTick();
      const form = this.$refs.form;
      if (!form || typeof form.getEditableFieldsDef !== 'function') {
        return [];
      }
      await this.waitInnerFormsReady(form);
      return form.getEditableFieldsDef();
    },
    /** 真正按 chunk 更新 UI 的流式读取（支持纯文本 / SSE） */
    async consumeAiStreamReader(reader) {
      const decoder = new TextDecoder();
      let lineBuffer = '';
      let display = '';
      let parsedObject;

      const updateDisplay = (text) => {
        display = text;
        this.aiStreamRaw = text;
      };

      const extractSseDelta = (lines) => {
        let delta = '';
        for (const line of lines) {
          const trimmed = line.trim();
          if (!trimmed.startsWith('data:')) {
            continue;
          }
          const raw = trimmed.replace(/^data:\s*/, '').trim();
          if (!raw || raw === '[DONE]') {
            continue;
          }
          try {
            const data = JSON.parse(raw);
            if (this._aiIsStreamJsonValue(data) && !Array.isArray(data)) {
              parsedObject = data;
            }
            const piece = (data.choices && data.choices[0] && data.choices[0].delta &&
              data.choices[0].delta.content) ||
              data.content || data.delta ||
              (typeof data.text === 'string' ? data.text : '');
            if (piece) {
              delta += piece;
            }
          } catch (e) {
            delta += raw;
          }
        }
        return delta;
      };

      while (true) {
        const {done, value} = await reader.read();
        if (done) {
          if (this._aiIsStreamJsonValue(value)) {
            parsedObject = value;
            updateDisplay(JSON.stringify(value, null, 2));
          } else if (value instanceof Uint8Array) {
            lineBuffer += decoder.decode(value, {stream: false});
          } else if (typeof value === 'string') {
            lineBuffer += value;
          }
          const tail = decoder.decode();
          if (tail) {
            lineBuffer += tail;
          }
          break;
        }
        if (value == null) {
          continue;
        }
        if (this._aiIsStreamJsonValue(value)) {
          parsedObject = value;
          updateDisplay(JSON.stringify(value, null, 2));
          continue;
        }
        const chunk = value instanceof Uint8Array ?
          decoder.decode(value, {stream: true}) :
          String(value);
        lineBuffer += chunk;

        if (lineBuffer.indexOf('data:') >= 0) {
          const lines = lineBuffer.split('\n');
          lineBuffer = lines.pop() || '';
          const delta = extractSseDelta(lines);
          if (delta) {
            updateDisplay(display + delta);
          }
        } else {
          updateDisplay(lineBuffer);
        }
      }

      if (lineBuffer.indexOf('data:') >= 0) {
        const delta = extractSseDelta([lineBuffer]);
        if (delta) {
          updateDisplay(display + delta);
        }
      } else if (lineBuffer && !display) {
        updateDisplay(lineBuffer);
      }

      return {
        text: display || lineBuffer,
        parsedObject,
      };
    },
    _collectValueDefKeys(defs, keys = new Set()) {
      (defs || []).forEach((d) => {
        if (d && d.key) {
          keys.add(d.key);
        }
        // object 内嵌表：子 fields 为对象内键；array(MultiForm) 的 fields 描述的是数组项，不是表单顶层键
        if (d && d.type === 'object' && Array.isArray(d.fields)) {
          this._collectValueDefKeys(d.fields, keys);
        }
      });
      return keys;
    },
    normalizeAiFormPayload(payload, valueDef) {
      let data = payload;
      if (data == null) {
        return {};
      }
      if (typeof data === 'string') {
        try {
          data = JSON.parse(this.cleanAiJsonOutput(data));
        } catch (e) {
          return {};
        }
      }
      if (typeof data !== 'object' || Array.isArray(data)) {
        return {};
      }
      const unwrapKeys = ['data', 'formData', 'result', 'form', 'model', 'value', 'content'];
      for (let i = 0; i < 3; i++) {
        const hit = unwrapKeys.find((k) => {
          const v = data[k];
          return v && typeof v === 'object' && !Array.isArray(v);
        });
        if (!hit) {
          break;
        }
        data = data[hit];
      }
      const fieldKeys = this._collectValueDefKeys(valueDef);
      if (fieldKeys.size > 0) {
        const topKeys = Object.keys(data);
        if (topKeys.length === 1 && typeof data[topKeys[0]] === 'object' && !Array.isArray(data[topKeys[0]])) {
          const inner = data[topKeys[0]];
          const innerKeys = Object.keys(inner);
          const matched = innerKeys.filter((k) => fieldKeys.has(k)).length;
          if (matched > 0 && matched >= Math.min(innerKeys.length, fieldKeys.size) * 0.5) {
            data = inner;
          }
        }
      }
      return data;
    },
    applyAiFormData(payload, valueDef) {
      const normalized = this.normalizeAiFormPayload(payload, valueDef);
      Object.keys(normalized).forEach((key) => {
        this.$set(this.formData, key, normalized[key]);
      });
      const merged = cloneDeep(this.formData);
      this.formRenderKey += 1;
      return this.$nextTick().then(() => {
        const form = this.$refs.form;
        if (form && typeof form.applyModel === 'function') {
          return form.applyModel(merged);
        }
        return merged;
      });
    },
    clearAiGenerationState() {
      this._stopAiFileParseProgress();
      this.aiStreamRaw = '';
      this.aiPreviewJson = '';
      this.aiParsedPayload = null;
      this.aiParseError = '';
      this.aiParseFailed = false;
      this.aiFileParsing = false;
      this.aiParsingFileList = [];
      this.aiFileParseDone = 0;
      this.aiPhase = 'input';
      this.aiMessage = '';
      this.aiMessageType = 'info';
    },
    _stopAiFileParseProgress() {
      if (this._aiParseProgressTimer) {
        clearInterval(this._aiParseProgressTimer);
        this._aiParseProgressTimer = null;
      }
    },
    _startAiFileParseProgress(total) {
      this._stopAiFileParseProgress();
      this.aiFileParseDone = 0;
      if (!total) {
        return;
      }
      this._aiParseProgressTimer = setInterval(() => {
        if (this.aiFileParseDone < total - 1) {
          this.aiFileParseDone += 1;
        }
      }, 700);
    },
    parseAiUserFiles(userFiles) {
      return new Promise((resolve, reject) => {
        this.$api.afterLogin(() => {
          this.$api.post('ai/buildUserFiles', {files: userFiles})
              .then((res) => {
                const data = res.data && res.data.data;
                if (!Array.isArray(data)) {
                  reject(new Error('附件解析返回格式错误'));
                  return;
                }
                resolve(data.map((item) => (item == null ? '' : String(item))));
              })
              .catch(reject);
        });
      });
    },
    buildAiUserContent(text, userFiles, fileMdList) {
      const parts = [
        '已有表单数据：',
        JSON.stringify(this.formData, null, 2),
        '',
        '用户描述：',
        text || '（无文字描述，请根据附件内容填写）',
      ];
      if (fileMdList && fileMdList.length) {
        parts.push('', '附件解析内容（Markdown，按上传顺序）：');
        fileMdList.forEach((md, i) => {
          const name = (userFiles[i] && userFiles[i].name) ? userFiles[i].name : `附件${i + 1}`;
          parts.push('', `### ${name}`, md && String(md).trim() ? String(md).trim() : '（未能解析出文本）');
        });
      }
      return parts.join('\n');
    },
    handleAiParseFailed(reason) {
      this.aiParsedPayload = null;
      this.aiPreviewJson = this.cleanAiJsonOutput(this.aiStreamRaw);
      this.aiParseError = reason;
      this.aiParseFailed = true;
      this.aiPhase = 'input';
      this.aiMessage = 'JSON 验证未通过，请修改描述后点击「重新生成」';
      this.aiMessageType = 'error';
    },
    retryAiGenerate() {
      if (this.aiLoading) {
        return;
      }
      this.aiParseFailed = false;
      this.aiParseError = '';
      this.aiMessage = '';
      this.submitAI();
    },
    submitAI() {
      if (this.aiLoading) {
        return;
      }
      this._submitAIDebounced();
    },
    buildAiUserFiles() {
      const files = (this.aiInput && this.aiInput.files) || [];
      return files.map((f) => ({
        name: f.name,
        type: f.type || f.ext || '',
        url: f.url || f.path || '',
      })).filter((f) => f.url);
    },
    parseAiStreamToPreview(valueDef, parsedObject) {
      try {
        let payload;
        if (parsedObject !== undefined && this._aiIsStreamJsonValue(parsedObject)) {
          payload = parsedObject;
        } else {
          const cleaned = this.cleanAiJsonOutput(this.aiStreamRaw);
          if (!cleaned) {
            this.handleAiParseFailed('AI 返回内容为空');
            return false;
          }
          payload = JSON.parse(cleaned);
        }
        if (typeof payload !== 'object' || payload === null || Array.isArray(payload)) {
          this.handleAiParseFailed('返回数据必须是 JSON 对象');
          return false;
        }
        const normalized = this.normalizeAiFormPayload(payload, valueDef);
        if (!Object.keys(normalized).length) {
          this.handleAiParseFailed('解析结果为空对象');
          return false;
        }
        this.aiParsedPayload = normalized;
        this.aiPreviewJson = JSON.stringify(normalized, null, 2);
        this.aiParseError = '';
        this.aiParseFailed = false;
        this.aiPhase = 'preview';
        this.aiMessage = '生成完成，请确认 JSON 后填入表单';
        this.aiMessageType = 'success';
        return true;
      } catch (e) {
        this.handleAiParseFailed('JSON 格式无效：' + (e && e.message ? e.message : e));
        return false;
      }
    },
    async _submitAI() {
      if (this.aiLoading || this.aiFileParsing) {
        return;
      }
      const text = (this.aiInput && this.aiInput.text) ? this.aiInput.text.trim() : '';
      const userFiles = this.buildAiUserFiles();
      if (!text && userFiles.length === 0) {
        this.aiMessage = '请输入描述或上传至少一个附件';
        this.aiMessageType = 'warning';
        return;
      }

      this.aiLoading = true;
      this.aiParseFailed = false;
      this.aiParseError = '';
      this.aiStreamRaw = '';
      this.aiPreviewJson = '';
      this.aiParsedPayload = null;

      let fileMdList = [];
      if (userFiles.length) {
        this.aiPhase = 'parsing';
        this.aiFileParsing = true;
        this.aiParsingFileList = userFiles.map((f) => ({name: f.name}));
        this.aiMessage = `正在解析 ${userFiles.length} 个附件…`;
        this.aiMessageType = 'info';
        this._startAiFileParseProgress(userFiles.length);
        try {
          fileMdList = await this.parseAiUserFiles(userFiles);
          this.aiFileParseDone = userFiles.length;
        } catch (e) {
          this.aiLoading = false;
          this.aiFileParsing = false;
          this._stopAiFileParseProgress();
          this.aiPhase = 'input';
          this.aiMessage = `附件解析失败：${e && e.message ? e.message : e}`;
          this.aiMessageType = 'error';
          return;
        } finally {
          this.aiFileParsing = false;
          this._stopAiFileParseProgress();
        }
      }

      this.aiPhase = 'streaming';
      this.aiMessage = 'AI 正在根据附件与描述生成…';
      this.aiMessageType = 'info';

      let valueDef;
      try {
        valueDef = await this.getFormValueDef();
      } catch (e) {
        this.aiLoading = false;
        this.aiMessage = '获取表单结构失败';
        this.aiMessageType = 'error';
        this.aiPhase = 'input';
        return;
      }
      this.aiValueDefCache = valueDef;

      const userContent = this.buildAiUserContent(text, userFiles, fileMdList);

      try {
        if (typeof this.$ai.chat !== 'function') {
          throw new Error('AI.chat 未就绪');
        }
        const reader = await this.$ai.chat({
          model_id: 'deepseek-v4',
          stream: true,
          messages: [{
            role: 'system',
            content: `你是表单填写助手。根据字段值结构及用户描述/附件，生成可提交的 JSON 对象。
要求：
1. 只返回 JSON 对象，不要 markdown 或解释文字；
2. 必须使用 fields 中的 key 作为 JSON 键，禁止使用 name（中文名称）作键；
3. 容器(Section/Tabs)已展开；type 为 object 的字段（如内嵌表 InnerForm）用其 key 作为对象键，子字段放在该对象内；
4. type 为 array 且 option.itemType 为 object 的字段（如多重表 MultiForm）用其 key 作为数组键，值为对象数组，每项对象的键见该字段的 fields；
5. 选择类 option.simple 为 true 时，值用选项 name；
6. 结合用户附件解析内容填表。
字段值结构（key 为提交键，name 仅作说明）：
${JSON.stringify(valueDef)}`,
          }, {
            role: 'user',
            content: userContent,
          }],
          value_type: 'text',
        });
        if (!reader || typeof reader.read !== 'function') {
          throw new Error('未能获取有效的流式 reader');
        }

        const {text, parsedObject} = await this.consumeAiStreamReader(reader);
        this.aiStreamRaw = text;
        if (!text || !String(text).trim()) {
          this.handleAiParseFailed('AI 未返回有效内容');
          return;
        }
        this.parseAiStreamToPreview(valueDef, parsedObject);
      } catch (e) {
        this.aiMessage = `AI 失败：${e && e.message ? e.message : e}`;
        this.aiMessageType = 'error';
        this.aiPhase = 'input';
      } finally {
        this.aiLoading = false;
      }
    },
    async confirmApplyAi() {
      const payload = this.aiParsedPayload;
      if (!payload || typeof payload !== 'object' || !Object.keys(payload).length) {
        this.aiMessage = '没有可填入的数据';
        this.aiMessageType = 'warning';
        return;
      }
      try {
        await this.applyAiFormData(payload, this.aiValueDefCache);
        this.clearAiGenerationState();
        this.showAIEditor = false;
        this.Success('已填入表单');
      } catch (e) {
        this.aiMessage = '填入失败：' + (e && e.message ? e.message : e);
        this.aiMessageType = 'error';
      }
    },
    getData() {
      this.loading_model = true;
      this.$api.afterLogin(()=>{
        this.$store.dispatch('model/load', {id: this.model, view: this.view}).then((def)=>{
          this.formDef = def;
          if (this.data && this.data.id) {
            this.formData = cloneDeep(this.data);
          } else {
            this.formData = this.initFormData();
          }
        }).catch((e)=>{
          this.Error(e);
        }).finally(()=>{
          this.loading_model = false;
        });
      });
    },
    initFormData() {
      return {};
    },
    stopLoading() {
      this.submitting = false;
    },
    submit() {
      this.$refs.form.submit();
    },
    handleSubmit(model) {
      this.submitting = true;
      if (this.data.id) {
        const updateData = this.$refs.form.getUpdateData();

        if (!updateData) {
          this.handleCancel();
          return;
        }

        this.$emit('on-event', {type: 'update', value: updateData});
      } else {
        this.$emit('on-event', {type: 'create', value: model});
      }
    },
    handleCancel() {
      this.$emit('input', false);
      this.$emit('on-event', {type: 'cancel'});
    },
  },
};
</script>

<style lang="less">
.ugo-ai-fill-modal {
  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-header {
    padding: 0;
    border-bottom: none;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    background: linear-gradient(135deg, #2d8cf0, #5cadff);
    border-radius: 6px 6px 0 0;
  }

  &__header-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 5px;
  }

  &__subtitle {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.92);
  }

  &__body {
    padding: 16px 20px 8px;
    max-height: 65vh;
    overflow-y: auto;
  }

  &__steps {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    font-size: 12px;
    color: var(--subtext2, #999);

    span {
      padding: 4px 10px;
      border-radius: 20px;
      background: var(--bg3, #f4f5f7);

      &.active {
        color: #2d8cf0;
        background: rgba(45, 140, 240, 0.12);
        font-weight: 600;
      }
    }
  }

  &__section {
    margin-bottom: 14px;
  }

  &__section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
    color: var(--text, #333);
  }

  &__status {
    margin: 8px 0 16px;
  }

  &__status-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 20px 24px;
    border-radius: 12px;
    text-align: center;

    &.is-streaming {
      background: linear-gradient(160deg, rgba(45, 140, 240, 0.08), rgba(92, 173, 255, 0.14));
      border: 1px solid rgba(45, 140, 240, 0.22);
    }

    &.is-success {
      background: linear-gradient(160deg, rgba(25, 190, 107, 0.08), rgba(45, 200, 120, 0.12));
      border: 1px solid rgba(25, 190, 107, 0.28);
      animation: ugo-ai-success-in 0.45s ease-out;
    }
  }

  &__status-title {
    margin: 16px 0 6px;
    font-size: 15px;
    font-weight: 600;
    color: var(--text, #333);
  }

  &__status-hint {
    margin: 0;
    font-size: 13px;
    color: var(--subtext2, #888);
    line-height: 1.5;
  }

  &__pulse-wrap {
    position: relative;
    width: 72px;
    height: 72px;
  }

  &__pulse-ring {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(45, 140, 240, 0.45);
    animation: ugo-ai-pulse-ring 1.8s ease-out infinite;

    &--2 {
      animation-delay: 0.6s;
    }
  }

  &__pulse-core {
    position: absolute;
    inset: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: linear-gradient(135deg, #2d8cf0, #5cadff);
    color: #fff;
    box-shadow: 0 4px 16px rgba(45, 140, 240, 0.35);
    animation: ugo-ai-pulse-core 1.2s ease-in-out infinite;
  }

  &__status-dots {
    display: flex;
    gap: 6px;
    margin-top: 14px;

    span {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #2d8cf0;
      animation: ugo-ai-dot-bounce 1.2s ease-in-out infinite;

      &:nth-child(2) { animation-delay: 0.15s; }
      &:nth-child(3) { animation-delay: 0.3s; }
    }
  }

  &__success-icon {
    color: #19be6b;
    animation: ugo-ai-success-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  &__parsing {
    padding: 12px;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.06), rgba(92, 173, 255, 0.1));
    border: 1px solid rgba(45, 140, 240, 0.2);
  }

  &__parsing-bar {
    height: 6px;
    margin: 10px 0 14px;
    border-radius: 6px;
    background: rgba(45, 140, 240, 0.15);
    overflow: hidden;
  }

  &__parsing-bar-inner {
    height: 100%;
    border-radius: 6px;
    background: linear-gradient(90deg, #2d8cf0, #5cadff);
    transition: width 0.35s ease;
  }

  &__parsing-list {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 10px;
      margin-bottom: 6px;
      border-radius: 8px;
      font-size: 13px;
      color: var(--subtext2, #666);
      background: var(--bg2, #fff);
      border: 1px solid transparent;
      transition: all 0.25s;

      &.active {
        color: #2d8cf0;
        border-color: rgba(45, 140, 240, 0.35);
        box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.12);
      }

      &.done {
        color: #19be6b;
      }
    }
  }

  &__parsing-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__message {
    font-size: 13px;
    padding: 8px 10px;
    border-radius: 6px;

    &.success { color: #19be6b; background: rgba(25, 190, 107, 0.08); }
    &.warning { color: #ff9900; background: rgba(255, 153, 0, 0.08); }
    &.error { color: #ed4014; background: rgba(237, 64, 20, 0.08); }
    &.info { color: #2d8cf0; background: rgba(45, 140, 240, 0.08); }
  }

  &__footer {
    padding: 12px 20px 16px;
    border-top: 1px solid var(--border, #e8eaec);
    gap: 8px;
  }
}

@keyframes ugo-ai-blink {
  50% { opacity: 0.4; }
}

.ugo-ai-parse-spin {
  animation: ugo-ai-parse-rotate 0.9s linear infinite;
}

@keyframes ugo-ai-parse-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes ugo-ai-pulse-ring {
  0% { transform: scale(0.75); opacity: 0.9; }
  100% { transform: scale(1.35); opacity: 0; }
}

@keyframes ugo-ai-pulse-core {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

@keyframes ugo-ai-dot-bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-6px); opacity: 1; }
}

@keyframes ugo-ai-success-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes ugo-ai-success-pop {
  0% { transform: scale(0.5); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
